<template>
  <header
    class="bg-primary text-white px-4 h-16 flex justify-between items-center"
  >
    <div class="flex items-center gap-4 h-full">
      <img
        src="/src/assets/images/logo-mafra-branco.png"
        class="h-[80%] object-contain"
      />

      <!-- Title -->
      <div class="flex flex-row gap-2 items-baseline">
        <h1 class="text-xl font-bold">
          {{ title }}
        </h1>
        <h3 class="text-xs">
          {{ subTitle }}
        </h3>
      </div>
    </div>

    <span class="text-sm opacity-80">v{{ version }}</span>
  </header>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";

const version = __APP_VERSION__;
const { t } = useI18n();
const route = useRoute();
const title = computed(() =>
  route.meta.headerTitleKey
    ? t(route.meta.headerTitleKey as string)
    : t("headerTitle.guro"),
);

const subTitle = computed(() =>
  route.meta.headerSubTitleKey ? t(route.meta.headerSubTitleKey as string) : "",
);
</script>
